<template>
  <transition name="modal" @after-enter="afterSlotLoaded">
    <div
      class="modal-mask"
      tabindex="0"
      @keyup.esc="onEscClicked"
      @click="onMaskClicked"
    >
      <div class="modal-wrapper">
        <div class="modal-container">
          <div v-if="closeIcon" class="close-icon-container">
            <Icon
              size="24"
              name="xmark"
              color="lightGreen"
              @click.native="close('icon')"
            />
          </div>
          <div class="modal-body">
            <transition name="modal-content" @after-enter="afterSlotChanged">
              <slot>
                default body
              </slot>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import clickOutside from '../directives/click-outside'
import Icon from './icon/Icon'

export default {
  components: {
    Icon,
  },

  directives: {
    clickOutside,
  },

  props: {
    closeIcon: {
      type: Boolean,
      default: false,
    },
    hoisted: {
      type: Boolean,
      default: false,
    },
    animateContent: {
      type: Boolean,
      default: false,
    },
    closeOnMaskClick: {
      type: Boolean,
      default: true,
    },
    closeOnEsc: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    if (this.hoisted) {
      window.document.body.appendChild(this.$el)
    }
    this.$el.focus()

    const htmlStyle = window.document.documentElement.style
    this.rootOverflow = htmlStyle.overflow
    htmlStyle.overflow = 'hidden'

    const mediaQueryList = window.matchMedia('print')
    mediaQueryList.addEventListener('change', mql => {
      if (mql.matches) {
        htmlStyle.height = 'auto'
        htmlStyle.display = 'block'
        htmlStyle.overflow = 'visible'
      } else {
        htmlStyle.overflow = this.rootOverflow
      }
    })
  },

  destroyed() {
    this.resetOverflow()
  },

  methods: {
    close(trigger) {
      this.$emit('close', { trigger })
    },

    resetOverflow() {
      window.document.documentElement.style.overflow = this.rootOverflow
    },

    onMaskClicked(e) {
      if (!this.closeOnMaskClick) {
        return
      }
      if (
        e.target.classList.contains('modal-mask') ||
        e.target.classList.contains('modal-wrapper')
      ) {
        this.close('mask')
      }
    },

    onEscClicked() {
      if (!this.closeOnEsc) {
        return
      }
      this.close('esc')
    },

    afterSlotLoaded(el) {
      if (!this.animateContent) {
        return
      }
      setTimeout(() => {
        const modalBody = el.getElementsByClassName('modal-body')[0]
        modalBody.style.height =
          modalBody.getBoundingClientRect().height.toString() + 'px'
      })
    },

    afterSlotChanged(el) {
      if (!this.animateContent) {
        return
      }
      setTimeout(() => {
        el.parentElement.style.height =
          el.getBoundingClientRect().height.toString() + 'px'
      })
    },
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(25, 25, 25, 0.5);
  display: flex;
  align-items: center;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  flex: 1;
  height: 100%;
  overflow: auto;

  @media (--md) {
    height: auto;
  }
}

.modal-container {
  margin: 0 auto;
  background-color: #fff;
  transition: all 0.3s ease;
  position: relative;
  height: 100%;
  overflow: auto;

  .modal-body {
    transition: height 0.3s ease-in-out;
  }

  .close-icon-container {
    float: right;
    margin: 5px 5px 0 0;
    > * {
      cursor: pointer;
    }
  }

  @media (--md) {
    width: 90%; /* change this size from outside if needed */
    max-height: 80vh; /* change this size from outside if needed */
  }

  @media (--lg) {
    width: 960px; /* change this size from outside if needed */
  }
}

.modal-default-button {
  float: right;
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
